module.exports = __webpack_public_path__ + "statics/img/cate6-4@2x.7fabbd0f.png";